@for (BRERequirement of BRERequirements(); track BRERequirement; let i = $index) {
  <section class="requirement-form border-bottom padding-bottom">
    <div class="article-component-cont no-margin no-border" id="form-{{ BRERequirement.ID }}" [ngClass]="{'bg-color': i % 2 === 0}">
      @if (BRERequirement.textareaControl?.getError('textareaError')) {
        <ent-alert-message type="warning">{{ message.addCommentSpeacialChar }}</ent-alert-message>
      }
      <header id="form-{{ BRERequirement.ID }}-header">
        <h4 class="ent-color"><i class="far fa-file-alt" aria-hidden="true"></i>{{ getRequirementHeader(BRERequirement) }} - </h4>
        <p>{{ BRERequirement.RequirementText }}</p>
      </header>
      <div aria-live="assertive">
        @if (BRERequirement.MsgState?.isWarning) {
          <ent-alert-message type="warning">{{ message.requirementWarningMsg }}</ent-alert-message>
        }
        @if (BRERequirement.MsgState?.isSuccess) {
          <ent-alert-message type="success" class="fade-out">{{ message.requirementSuccessMsg }}</ent-alert-message>
        }
        @if (BRERequirement.MsgState?.isError) {
          <ent-alert-message type="error">{{ message.requirementErrorMsg }}</ent-alert-message>
        }
      </div>
      <form action="javascript:void(0);">
        <div class="form--control">
          @if (BRERequirement.textareaControl) {
            <textarea id="{{BRERequirement.ID}}"
              entValidateOnBlur
              class="form--control--text-area"
              [ngClass]="{'inp-txt--err': BRERequirement?.textareaControl?.touched && BRERequirement.textareaControl.invalid && (BRERequirement.CommentFormError || (BRERequirement.textareaControl.value !== '' && BRERequirement.textareaControl.value !== null))}"
              [formControl]="BRERequirement.textareaControl"
              (focusout)="resetError(BRERequirement);"
              (keyup)="textareaKeyup(BRERequirement);"
              required maxlength="1000">
            </textarea>
          }
          <label class="inp-float__placeholder"
            [ngClass]="{'inp-float__placeholder--float': BRERequirement.textareaControl?.value !== '' && BRERequirement.textareaControl?.value !== null }"
            for="{{BRERequirement.ID}}">Enter your comment
          </label>
          <div aria-live="assertive">
            @if (BRERequirement.textareaControl?.touched && BRERequirement.textareaControl?.invalid && BRERequirement.CommentFormError && !BRERequirement.textareaControl?.getError('textareaError')) {
              <ent-error
                message="Please enter your comment.">
              </ent-error>
            }
            @if (BRERequirement.textareaControl?.touched && BRERequirement.textareaControl?.invalid && BRERequirement.textareaControl?.value !== '' && BRERequirement.textareaControl?.value !== null ) {
              <ent-error
                message="Please enter valid comment.">
              </ent-error>
            }
            @if (requirementCompletedFlagADA[i]) {
              <span class="screen-reader-only">requirement completed.</span>
            }
          </div>
        </div>
        <ent-left-button-tray>
          <button type="button" entDefaultButton [disabled]="BRERequirement.RequirementStatus === 'Complete' || isHOUser" (click)="addComment(BRERequirement, i)">
            Add comment
          </button>
          <button type="button" entBorderButton id="uploadFileBtn-{{ BRERequirement.ID }}" [disabled]="BRERequirement.RequirementStatus === 'Complete' || isHOUser" (click)="triggerUploadFileModal(BRERequirement, i)">
            <i class="fas fa-upload" aria-hidden="true"></i> Upload file
          </button>
          <button type="button" entDefaultButton id="downloadFileBtn-{{ BRERequirement.ID }}" [disabled]="BRERequirement.RequirementStatus === 'Complete' || getFileCount(BRERequirement) || isHantzReadOnly || (isHOUser && isBOE)" (click)="triggerDownloadFileModal(BRERequirement, i)">
            <i class="fas fa-download" aria-hidden="true"></i> Download Files
          </button>
        </ent-left-button-tray>
      </form>
    </div>
    <div class="hr-line"></div>
    <ent-primary-table (tableSortTriggered)="tableSortTriggered($event, i)" [tableData]="outstandingCommentsTableCustomData[i]"></ent-primary-table>
    <div class="view-links" aria-live="off">
      @if (outstandingCommentsTableCustomData[i].data.length > outstandingCommentsTableCustomData[i].config.rowsPerPage) {
        <a
          id="viewall" href="javascript:void(0)" (click)="viewAllrows(i)" aria-expanded="false">
          View comments ({{ outstandingCommentsTableCustomData[i].data.length }})
          <i class="fas fa-caret-down" aria-hidden="true"></i>
        </a>
      }
      @if ((outstandingCommentsTableCustomData[i].config.rowsPerPage > outstandingCommentsTableRowsPerPage)) {
        <a
          id="viewless" href="javascript:void(0)" (click)="viewLessrows(i)" aria-expanded="true">View less comments
          <i class="fas fa-caret-up" aria-hidden="true"></i>
        </a>
      }
    </div>
  </section>
}

@if (uploadBRERequirement?.UploadFile?.ModalState) {
  <app-upload-file [index]="index" [BRERequirement]="uploadBRERequirement" [outstandingCommentsTableCustomData]="uploadOutstandingCommentsTableCustomData"></app-upload-file>
}

@if (downloadBRERequirement?.DownloadFile?.ModalState) {
  <app-download-file [index]="index" [BRERequirement]="downloadBRERequirement" [outstandingCommentsTableCustomData]="downloadOutstandingCommentsTableCustomData" [isHOUser]="isHOUser"></app-download-file>
}
